<section>
  @if (isSummaryDataLoading()) {
    <!-- To avoid race condtiion - added this skeleton for now. Need to understand better why there is
      a race condtiion when thse values are not defined at the start
    -->
    @if (!!item) {
      <cor-skeleton [type]="SKELETON_TYPES.GRID" />
    }
  } @else if (item()?.currentStatus === WORKFLOW_STATUS.ARCHIVED) {
    <cor-no-data
      [showIcon]="true"
      noDataMessage=""
      class="tw:block tw:mb-3">
      <p class="tw:text-center tw:text-muted-color">
        Approvals are not available while this object is archived.
        <br />
        <br />
        Change the status back to
        <b>Draft</b>
        from the menu to continue.
      </p>
    </cor-no-data>
  } @else if (!isApprovalAllowed() && item()?.actions?.[ACTIONS.WRITE]) {
    <cor-no-data
      [showIcon]="true"
      noDataMessage=""
      class="tw:block tw:mb-3">
      <p class="tw:text-center tw:text-muted-color">
        An 'Approval Workflow' is required to begin the approval process for this object
        <br />
        Please select one to continue:
      </p>
      <div class="tw:flex tw:flex-col tw:items-center tw:gap-2 tw:justify-center">
        <cor-workflow-selection
          [currentStatus]="item()?.currentStatus"
          [object]="object()"
          [formControl]="approvalWorkflow.workflowIdControl"
          (ngModelChange)="setApprovalWorkflow()" />
        @if (approvalWorkflow.isSaving()) {
          <div class="tw:text-muted-color">Saving...</div>
        }
      </div>
    </cor-no-data>
    <ng-container *ngTemplateOutlet="lineageDiffTemplate" />
  } @else {
    <div
      class="card tw:mb-3"
      test-id="approval-status-card">
      <div class="card-header">
        <div class="card-title">
          <h5>Approval Status</h5>
        </div>
        <div class="tw:grow tw:justify-end tw:flex tw:gap-2 tw:self-center">
          <cor-workflow-selection
            class="col-4"
            [currentStatus]="item()?.currentStatus"
            [object]="object()"
            [formControl]="approvalWorkflow.workflowIdControl"
            (ngModelChange)="setApprovalWorkflow()" />

          <!-- Show only for requestor and item is not approved -->
          @if (!(NON_EDITABLE_STATUS | includes: item()?.currentStatus)) {
            <div class="tw:flex tw:gap-2">
              @if (WORKFLOW_STATUS.PENDING_APPROVAL === item()?.currentStatus) {
                <!-- only user with Write access could see the close button -->
                @if (
                  item()?.actions?.[ACTIONS.WRITE] &&
                  (!groupApprovalParentObject()?.objectId ||
                    groupApprovalParentObject()?.objectId === item()?.id)
                ) {
                  <p-button
                    test-id="approval-review-workflow-revert-to-draft"
                    [buttonProps]="{ autofocus: false }"
                    (click)="showRecallConfirmation()"
                    pTooltip="Cancel all active reviews and revert the Object status to Draft"
                    variant="outlined"
                    severity="danger"
                    label="Revert to Draft" />
                }
              }
              @if (item()?.actions?.[ACTIONS.WRITE]) {
                @if (
                  !groupApprovalParentObject()?.objectId ||
                  groupApprovalParentObject()?.objectId === item()?.id
                ) {
                  <!-- Add Reviewers -->
                  <cor-approval-action
                    [summaryDatasource]="summaryDatasource()"
                    [workflowId]="approvalWorkflow.workflowIdControl.value"
                    [object]="object()"
                    [id]="item().id" />
                }
              }
            </div>
          }
        </div>
      </div>
      @if (isSummaryDataLoading()) {
        <cor-skeleton [type]="SKELETON_TYPES.GRID" />
      } @else {
        <div class="card-body">
          <div class="tw:mb-4">
            @if (summaryDatasource().length > 0) {
              <dx-data-grid
                [showRowLines]="true"
                [showColumnLines]="false"
                [wordWrapEnabled]="true"
                [dataSource]="summaryDatasource()"
                [masterDetail]="{ enabled: true, template: 'inputs' }"
                (onRowPrepared)="paintExpandableBtn($event)"
                (onEditorPreparing)="onEditorPreparing($event)"
                [columns]="columns">
                <!-- Date Template -->
                <div *dxTemplate="let row of 'dateTemplate'">
                  {{ row.value | localDate: 'date' }}
                </div>

                <!-- Review Type -->
                <div *dxTemplate="let row of 'typeTemplate'">
                  {{ row.value | titlecase }}
                </div>

                <!-- Action Template -->
                <div *dxTemplate="let data of 'actionTemplate'">
                  @if (
                    !groupApprovalParentObject()?.objectId ||
                    groupApprovalParentObject().objectId === item()?.id
                  ) {
                    @if (data.value && data.value.length > 0) {
                      <p-button
                        test-id="approval-review-actions"
                        [buttonProps]="{ autofocus: false }"
                        type="button"
                        (click)="actionMenu.toggle($event)"
                        rounded
                        variant="text"
                        severity="secondary"
                        icon="pi pi-ellipsis-v" />
                      <p-menu
                        #actionMenu
                        [model]="data.data.menuItems"
                        appendTo="body"
                        [popup]="true"
                        [style]="{ width: '15rem' }" />
                    }
                  }
                </div>

                <!-- Active Reviewers Template -->
                <div *dxTemplate="let data of 'activeReviewersTemplate'">
                  <div class="tw:flex tw:flex-wrap tw:items-center tw:gap-3">
                    @for (reviewer of data.value; track reviewer; let last = $last) {
                      <div class="tw:flex tw:items-center tw:gap-2">
                        <p-avatar
                          class="tw:shrink-0 tw:self-center"
                          [label]="reviewer || '' | nameBadge"
                          style="
                            --p-avatar-width: 1.5rem;
                            --p-avatar-height: 1.5rem;
                            --p-avatar-font-size: 0.75rem;
                          "
                          [ngStyle]="{
                            backgroundColor: (reviewer || '' | uniqueRgbColor),
                            color: 'white',
                          }"
                          shape="circle" />
                        {{ reviewer }}
                      </div>
                      @if (!last) {
                        <span>,</span>
                      }
                    }
                  </div>
                </div>

                <!-- Status Template -->
                <div *dxTemplate="let data of 'statusTemplate'">
                  <span>
                    <cor-status-icon [status]="data.value" />
                  </span>
                </div>

                <!-- Tag Template -->
                <div *dxTemplate="let row of 'tagTemplate'">
                  <span>{{ row.value }}</span>
                </div>

                <div *dxTemplate="let data of 'inputs'">
                  <div class="max-height-250">
                    <dx-data-grid
                      [dataSource]="data.data.inputs"
                      [showRowLines]="true"
                      [showColumnLines]="false"
                      [columnAutoWidth]="true"
                      (onEditorPreparing)="onEditorPreparing($event)">
                      <dxi-data-grid-column
                        [allowSorting]="false"
                        [allowFiltering]="false"
                        [allowSearch]="false"
                        caption="Name"
                        dataField="name"
                        cellTemplate="nameLinkTemplate" />
                      <dxi-data-grid-column
                        [allowSorting]="false"
                        [allowFiltering]="false"
                        [allowSearch]="false"
                        caption="Object Type"
                        dataField="objectType" />
                      <div
                        class="tw:flex tw:flex-row"
                        *dxTemplate="let data of 'nameLinkTemplate'">
                        <a
                          test-id="approval-review-workflow-link"
                          [routerLink]="data.data.link"
                          target="_blank">
                          <span class="tw:text-sky-600">{{ data.data.name }}</span>
                        </a>
                      </div>
                      <div *dxTemplate="let data of 'objectType'">
                        {{ data.data.objectType }}
                      </div>
                    </dx-data-grid>
                  </div>
                </div>
              </dx-data-grid>
            } @else {
              <cor-no-data
                [showIcon]="true"
                noDataMessage="">
                <p class="tw:text-center tw:text-muted-color">
                  @if (item()?.actions?.[ACTIONS.WRITE]) {
                    Please initiate the approval by clicking on
                    <strong>Request Approval</strong>
                  } @else {
                    You need to have write access to the object to
                    <strong>Request Approval</strong>
                  }
                </p>
              </cor-no-data>
            }
          </div>
        </div>
      }
    </div>
    @if (object() === OBJECTS.PIPELINE) {
      <cor-pipeline-risk-assessment
        [id]="id()"
        [showCreateOnly]="true" />
    }

    <ng-container *ngTemplateOutlet="lineageDiffTemplate" />

    @if (
      groupApprovalParentObject()?.objectId && groupApprovalParentObject().objectId !== item().id
    ) {
      <p-message
        severity="warn"
        icon="pi pi-info-circle"
        class="tw:mb-3 tw:p-3">
        @if (item().currentStatus === WORKFLOW_STATUS.PENDING_APPROVAL) {
          Group Approval - See
          <a
            test-id="approval-review-workflow-s"
            class="tw:cursor-pointer tw:text-sky-600 tw:hover:text-blue-500 tw:hover:underline"
            [routerLink]="parentGroupedApprovalLink()"
            target="_blank">
            {{ groupApprovalParentObject().objectName }}'s
          </a>
          approval tab for more details.
        } @else {
          Reviewed as part of
          <strong>{{ groupApprovalParentObject().objectName }}</strong>
          's approval request - Please check
          <a
            test-id="approval-review-workflow-s-2"
            class="tw:cursor-pointer tw:text-sky-600 tw:hover:text-blue-500 tw:hover:underline"
            [routerLink]="parentGroupedApprovalLink()"
            target="_blank">
            {{ groupApprovalParentObject().objectName }}'s
          </a>
          approval history for more details.
        }
      </p-message>
    }

    <cor-timeline
      [id]="id()"
      [object]="object()"
      [service]="service()" />
  }
</section>

<ng-template #lineageDiffTemplate>
  <div class="card tw:mb-3">
    <div class="card-header">
      <div class="card-title tw:gap-4">
        <h5>Changes</h5>
        <div class="tw:flex tw:items-center tw:gap-2">
          @if (lineageDiff.versionList().length > 0) {
            <p-select
              test-id="approval-review-workflow-select-version"
              class="tw:border-none tw:shadow-none tw:p-0"
              style="
                --p-select-background: var(--p-tag-danger-background);
                --p-select-dropdown-color: var(--p-tag-danger-color);
                --p-select-dropdown-width: 1.8rem;
                --p-select-sm-padding-y: 0;
                --p-select-sm-padding-x: 0;
              "
              [options]="lineageDiff.versionList()"
              [(ngModel)]="lineageDiff.selectedVersionId"
              (ngModelChange)="getLineageDiffData()"
              optionLabel="displayName"
              optionValue="id"
              appendTo="body"
              placeholder="Select version"
              size="small">
              <ng-template
                pTemplate="selectedItem"
                let-selectedVersion>
                <p-tag
                  severity="danger"
                  icon="pi pi-history"
                  [value]="selectedVersion.displayName" />
              </ng-template>
            </p-select>
            <i class="pi pi-arrow-right tw:text-muted-color"></i>
          }
          <p-tag
            severity="success"
            [value]="`Version ${item().version}`" />
        </div>
      </div>
    </div>
    <div class="card-body">
      @if (lineageDiff.isLoading()) {
        <cor-skeleton [type]="SKELETON_TYPES.GRID" />
      } @else {
        <div class="tw:flex tw:flex-col tw:gap-1">
          @if (lineageDiff.diffData().length === 0) {
            <cor-no-data noDataMessage="No changes found" />
          } @else {
            @for (diffItem of lineageDiff.diffData(); track `${diffItem.object}-${diffItem.id}`) {
              <cor-object-diff-viewer [diffData]="diffItem" />
            }
          }
        </div>
      }
    </div>
  </div>
</ng-template>

<!-- Pop up to update the status -->
<cor-dialog-box
  [(visible)]="isStatusUpdatePopupVisible"
  [title]="updateStatusPopUpTitle()"
  (onHide)="onCancelClick()">
  @if (commentForm()) {
    <cor-input-container
      label="Comment"
      test-id="comment">
      <cor-description
        test-id="approval-review-workflow-comment"
        [minHeight]="70"
        placeholder="Here you can put a brief comment"
        [formControl]="commentForm().controls.comment" />
    </cor-input-container>
    <!-- Checkbox for grouped approval (v1.25.x approach) -->
    @if (
      commentForm().controls.isAccepted &&
      reviewPayload?.type === APPROVAL_TYPE.GROUPED &&
      ([REVIEW_STATUS.ACCEPTED, REVIEW_STATUS.REJECTED] | includes: reviewPayload?.status)
    ) {
      <cor-input-container errorMsg="Select this checkbox to proceed further">
        <div class="tw:flex tw:items-center tw:gap-2">
          <p-checkbox
            test-id="approval-review-workflow-is-accepted"
            [formControl]="commentForm().controls.isAccepted"
            [binary]="true" />
          <label class="mandatory">
            {{
              `Accepting this will ${
                reviewPayload?.status === REVIEW_STATUS.ACCEPTED ? 'approve' : 'reject'
              }`
            }}
            all the lineage objects which are used as inputs for this object
          </label>
        </div>
      </cor-input-container>
    }
  }
  <ng-template #footer>
    <div class="tw:flex tw:gap-2">
      <p-button
        test-id="approval-review-workflow-cancel-changes"
        [buttonProps]="{ autofocus: false }"
        (click)="onCancelClick()"
        severity="secondary"
        label="Cancel Changes" />
      <p-button
        test-id="approval-review-workflow-save-changes"
        [buttonProps]="{ autofocus: false }"
        [loading]="isSaving()"
        [disabled]="isSaving()"
        (click)="onSaveClick()"
        [label]="isSaving() ? 'Saving...' : 'Save Changes'" />
    </div>
  </ng-template>
</cor-dialog-box>
